<script>
	export let bgImage = null
	export let bg = null
	export let bgColor = 'bg-neutral-900'
	export let opaque = null
	export let bgWidthLimit = false
</script>

<div
	class="
    sectionHero absolute left-0 top-0
    w-full
    {bgColor} 
  "
>
	<div
		style="{bg ? 'background:' + bg + ';' : ''} {bgImage
			? "background-image: url('" + bgImage + "');"
			: ''}"
		class="imageHolder {bgWidthLimit ? 'imageHolder--limited' : ''} block w-full {opaque
			? 'opacity-100'
			: 'opacity-20'} bg-no-repeat"
	/>
</div>

<style>
	.imageHolder {
		background-position: center;
		height: 30vh;
		min-height: 380px;
	}

	@screen lg {
		.imageHolder--limited {
			background-size: min(100vw, 1360px) auto;
		}
	}
</style>
